import React from 'react';
export function TypographyScale() {
  return <div className="space-y-8 p-8 bg-white rounded-lg border border-film-border" data-id="element-345">
      <div className="mb-6 p-4 bg-film-cream rounded border-l-4 border-film-red" data-id="element-346">
        <p className="text-sm text-film-gray mb-2" data-id="element-347">
          <strong className="text-film-black" data-id="element-348">Brand Fonts:</strong>
        </p>
        <p className="text-sm text-film-gray" data-id="element-349">
          <span className="font-display font-bold" data-id="element-350">Futura Extra Condensed</span>{' '}
          for headings and bold text
        </p>
        <p className="text-sm text-film-gray" data-id="element-351">
          Helvetica Neue for body text and UI elements
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-352">
        <span className="text-film-gray text-sm font-mono" data-id="element-353">Header 1</span>
        <div className="md:col-span-3" data-id="element-354">
          <h1 className="text-4xl font-display font-bold text-film-black tracking-tight" data-id="element-355">
            Film Notes Brand
          </h1>
          <p className="text-xs text-film-gray mt-1" data-id="element-356">
            Futura Extra Condensed Bold • 36px/40px • Tight Tracking
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-357">
        <span className="text-film-gray text-sm font-mono" data-id="element-358">Header 2</span>
        <div className="md:col-span-3" data-id="element-359">
          <h2 className="text-2xl font-display font-bold text-film-black" data-id="element-360">
            Capture Every Detail
          </h2>
          <p className="text-xs text-film-gray mt-1" data-id="element-361">
            Futura Extra Condensed Bold • 24px/32px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-362">
        <span className="text-film-gray text-sm font-mono" data-id="element-363">Section Label</span>
        <div className="md:col-span-3" data-id="element-364">
          <h3 className="text-sm font-display font-bold text-film-gray uppercase tracking-wider" data-id="element-365">
            Loaded Rolls
          </h3>
          <p className="text-xs text-film-gray mt-1" data-id="element-366">
            Futura Extra Condensed Bold • Uppercase • Wide Tracking • 14px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-367">
        <span className="text-film-gray text-sm font-mono" data-id="element-368">Body Large</span>
        <div className="md:col-span-3" data-id="element-369">
          <p className="text-lg text-film-black" data-id="element-370">
            A simple, intuitive hub for managing, tracking, and exploring your
            analog photography.
          </p>
          <p className="text-xs text-film-gray mt-1" data-id="element-371">
            Helvetica Neue Regular • 18px/28px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline" data-id="element-372">
        <span className="text-film-gray text-sm font-mono" data-id="element-373">Body Small</span>
        <div className="md:col-span-3" data-id="element-374">
          <p className="text-sm text-film-gray" data-id="element-375">
            French humanist photographer who co-founded Magnum Photos and is
            considered a pioneer of street photography.
          </p>
          <p className="text-xs text-film-gray mt-1" data-id="element-376">
            Helvetica Neue Regular • 14px/20px
          </p>
        </div>
      </div>
    </div>;
}